// ============================================
// API CONFIGURATION
// ============================================
export const API_BASE_URL = '/api';
export const API_ENDPOINTS = {
    // Auth
    LOGIN: `${API_BASE_URL}/auth/login`,
    SIGNUP: `${API_BASE_URL}/auth/signup`,
    VERIFY_EMAIL: `${API_BASE_URL}/auth/verify-email`,
    RESEND_VERIFICATION: `${API_BASE_URL}/auth/resend-verification`,
    FORGOT_PASSWORD: `${API_BASE_URL}/auth/forgot-password`,
    RESET_PASSWORD: `${API_BASE_URL}/auth/reset-password`,
    ACCEPT_INVITE: `${API_BASE_URL}/auth/accept-invite`,
    MAGIC_LINK_REQUEST: `${API_BASE_URL}/auth/magic-link/request`,
    MAGIC_LINK_VERIFY: `${API_BASE_URL}/auth/magic-link/verify`,
    REFRESH: `${API_BASE_URL}/auth/refresh`,
    ME: `${API_BASE_URL}/auth/me`,
    GOOGLE_AUTH: `${API_BASE_URL}/auth/google`,
    MICROSOFT_AUTH: `${API_BASE_URL}/auth/microsoft`,
    PROFILE: `${API_BASE_URL}/auth/profile`,
    CHANGE_PASSWORD: `${API_BASE_URL}/auth/change-password`,
    // Feedback (public)
    AMENITY_BY_QR: (code) => `${API_BASE_URL}/feedback/amenity/${code}`,
    FEEDBACK: `${API_BASE_URL}/feedback`,
    // Tasks
    TASKS: `${API_BASE_URL}/tasks`,
    TASK: (id) => `${API_BASE_URL}/tasks/${id}`,
    TASK_STATUS: (id) => `${API_BASE_URL}/tasks/${id}/status`,
    // Dashboard
    DASHBOARD_OVERVIEW: `${API_BASE_URL}/dashboard/overview`,
    DASHBOARD_FEEDBACK: `${API_BASE_URL}/dashboard/feedback`,
    DASHBOARD_AMENITY_PERFORMANCE: `${API_BASE_URL}/dashboard/amenities/performance`,
    DASHBOARD_STATUS_METRICS: `${API_BASE_URL}/dashboard/status-metrics`,
    DASHBOARD_MILESTONES: `${API_BASE_URL}/dashboard/milestones`,
    DASHBOARD_SCOUT_ANALYTICS: `${API_BASE_URL}/dashboard/scout-analytics`,
    DASHBOARD_SLA: `${API_BASE_URL}/dashboard/sla`,
    DASHBOARD_REPORTS: `${API_BASE_URL}/dashboard/reports`,
    DASHBOARD_REPORT_GENERATE: `${API_BASE_URL}/dashboard/reports/generate`,
    DASHBOARD_REPORT_DOWNLOAD: (id) => `${API_BASE_URL}/dashboard/reports/${id}/download`,
    // Export
    EXPORT_FEEDBACK: `${API_BASE_URL}/export/feedback`,
    EXPORT_TASKS: `${API_BASE_URL}/export/tasks`,
    EXPORT_STATUS_REPORTS: `${API_BASE_URL}/export/status-reports`,
    // Dashboard - Status Reports
    DASHBOARD_STATUS_REPORTS: `${API_BASE_URL}/dashboard/status-reports`,
    // Admin
    ADMIN_BUILDINGS: `${API_BASE_URL}/admin/buildings`,
    ADMIN_BUILDING: (id) => `${API_BASE_URL}/admin/buildings/${id}`,
    ADMIN_LOCATIONS: `${API_BASE_URL}/admin/locations`,
    ADMIN_LOCATION: (id) => `${API_BASE_URL}/admin/locations/${id}`,
    ADMIN_LOCATION_TREE: `${API_BASE_URL}/admin/locations/tree`,
    ADMIN_LOCATION_TYPES: `${API_BASE_URL}/admin/location-types`,
    ADMIN_LOCATION_TYPE: (id) => `${API_BASE_URL}/admin/location-types/${id}`,
    ADMIN_LOCATION_ANCESTORS: (id) => `${API_BASE_URL}/admin/locations/${id}/ancestors`,
    ADMIN_AMENITIES: `${API_BASE_URL}/admin/amenities`,
    ADMIN_AMENITY: (id) => `${API_BASE_URL}/admin/amenities/${id}`,
    ADMIN_AMENITY_TYPES: `${API_BASE_URL}/admin/amenity-types`,
    ADMIN_AMENITY_TYPE: (id) => `${API_BASE_URL}/admin/amenity-types/${id}`,
    ADMIN_AMENITY_TYPE_NODES: `${API_BASE_URL}/admin/amenity-type-nodes`,
    ADMIN_AMENITY_TYPE_NODE: (id) => `${API_BASE_URL}/admin/amenity-type-nodes/${id}`,
    ADMIN_AMENITY_TYPE_NODE_CHILDREN: (id) => `${API_BASE_URL}/admin/amenity-type-nodes/${id}/children`,
    ADMIN_USERS: `${API_BASE_URL}/admin/users`,
    ADMIN_USER: (id) => `${API_BASE_URL}/admin/users/${id}`,
    ADMIN_USER_DELETE_CHECK: (id) => `${API_BASE_URL}/admin/users/${id}/delete-check`,
    ADMIN_USER_RESEND_INVITE: (id) => `${API_BASE_URL}/admin/users/${id}/resend-invite`,
    ADMIN_ROUTING_RULES: `${API_BASE_URL}/admin/routing-rules`,
    ADMIN_ROUTING_RULE: (id) => `${API_BASE_URL}/admin/routing-rules/${id}`,
    ADMIN_QR_CODE: (id) => `${API_BASE_URL}/admin/qr-codes/${id}`,
    ADMIN_QR_CODES_AVAILABLE: `${API_BASE_URL}/admin/qr-codes/available`,
    ADMIN_QR_CODES_LOOKUP: (code) => `${API_BASE_URL}/admin/qr-codes/lookup?code=${encodeURIComponent(code)}`,
    ADMIN_QR_CODES_ASSIGN: `${API_BASE_URL}/admin/qr-codes/assign`,
    ADMIN_QR_CODES_ASSIGN_BATCH: `${API_BASE_URL}/admin/qr-codes/assign-batch`,
    ADMIN_QR_CODE_UNASSIGN: (id) => `${API_BASE_URL}/admin/qr-codes/${id}/unassign`,
    // RAG / Building Knowledge
    ADMIN_BUILDING_KNOWLEDGE: `${API_BASE_URL}/admin/building-knowledge`,
    ADMIN_RAG_QUESTIONS: `${API_BASE_URL}/admin/rag-questions`,
    // RAG seed prompts (v2 visitor PWA suggestion chips)
    ADMIN_RAG_PROMPTS: `${API_BASE_URL}/admin/rag-prompts`,
    ADMIN_RAG_PROMPT: (id) => `${API_BASE_URL}/admin/rag-prompts/${id}`,
    ADMIN_RAG_PROMPTS_REORDER: `${API_BASE_URL}/admin/rag-prompts/reorder`,
    // QR Cards (animal card system)
    ADMIN_QR_CARDS: `${API_BASE_URL}/admin/qr-cards`,
    ADMIN_QR_CARD_IMAGE: (qrCodeId) => `${API_BASE_URL}/admin/qr-cards/${qrCodeId}/card`,
    ADMIN_QR_CARDS_BATCH: `${API_BASE_URL}/admin/qr-cards/batch`,
    ADMIN_QR_CARDS_PDF: `${API_BASE_URL}/admin/qr-cards/pdf`,
    ADMIN_STATUS_TYPES: `${API_BASE_URL}/admin/status-types`,
    ADMIN_STATUS_TYPE: (id) => `${API_BASE_URL}/admin/status-types/${id}`,
    ADMIN_AMENITY_TYPE_STATUS_TYPES: (id) => `${API_BASE_URL}/admin/amenity-types/${id}/status-types`,
    ADMIN_AMENITY_STATUS_ITEMS: (id) => `${API_BASE_URL}/admin/amenities/${id}/status-items`,
    ADMIN_AMENITY_RESET_STATUS: (id) => `${API_BASE_URL}/admin/amenities/${id}/reset-status`,
    // Admin - Tags
    ADMIN_TAGS: `${API_BASE_URL}/admin/tags`,
    ADMIN_TAG: (id) => `${API_BASE_URL}/admin/tags/${id}`,
    ADMIN_TAG_ASSIGN: (id) => `${API_BASE_URL}/admin/tags/${id}/assign`,
    ADMIN_TAG_UNASSIGN: (id) => `${API_BASE_URL}/admin/tags/${id}/unassign`,
    ADMIN_TAG_BY_RESOURCE: (type, resourceId) => `${API_BASE_URL}/admin/tags/by-resource/${type}/${resourceId}`,
    ADMIN_TAGS_BATCH: `${API_BASE_URL}/admin/tags/batch`,
    // Admin - Escalation
    ADMIN_ESCALATION_RULES: `${API_BASE_URL}/admin/escalation-rules`,
    ADMIN_ESCALATION_RULE: (priority) => `${API_BASE_URL}/admin/escalation-rules/${priority}`,
    ADMIN_ESCALATION_RULE_DELETE: (id) => `${API_BASE_URL}/admin/escalation-rules/${id}`,
    // Admin - SLA Targets
    ADMIN_SLA_TARGETS: `${API_BASE_URL}/admin/sla-targets`,
    ADMIN_SLA_TARGET: (priority) => `${API_BASE_URL}/admin/sla-targets/${priority}`,
    // Admin - Shift Schedules
    ADMIN_SHIFT_SCHEDULES: `${API_BASE_URL}/admin/shift-schedules`,
    ADMIN_SHIFT_SCHEDULE: (id) => `${API_BASE_URL}/admin/shift-schedules/${id}`,
    ADMIN_SHIFT_ASSIGNMENTS: (scheduleId) => `${API_BASE_URL}/admin/shift-schedules/${scheduleId}/assignments`,
    ADMIN_SHIFT_ASSIGNMENT: (scheduleId, assignmentId) => `${API_BASE_URL}/admin/shift-schedules/${scheduleId}/assignments/${assignmentId}`,
    // Admin - Duplication
    ADMIN_BUILDING_DUPLICATE: (id) => `${API_BASE_URL}/admin/buildings/${id}/duplicate`,
    ADMIN_LOCATION_DUPLICATE: (id) => `${API_BASE_URL}/admin/locations/${id}/duplicate`,
    ADMIN_AMENITY_DUPLICATE: (id) => `${API_BASE_URL}/admin/amenities/${id}/duplicate`,
    // Admin - Move
    ADMIN_AMENITY_MOVE: (id) => `${API_BASE_URL}/admin/amenities/${id}/move`,
    ADMIN_LOCATION_MOVE: (id) => `${API_BASE_URL}/admin/locations/${id}/move`,
    ADMIN_AMENITIES_BULK_MOVE: `${API_BASE_URL}/admin/amenities/bulk-move`,
    ADMIN_LOCATIONS_BULK_MOVE: `${API_BASE_URL}/admin/locations/bulk-move`,
    // Admin - Bulk Duplication
    ADMIN_BUILDINGS_BULK_DUPLICATE: `${API_BASE_URL}/admin/buildings/bulk-duplicate`,
    ADMIN_LOCATIONS_BULK_DUPLICATE: `${API_BASE_URL}/admin/locations/bulk-duplicate`,
    ADMIN_AMENITIES_BULK_DUPLICATE: `${API_BASE_URL}/admin/amenities/bulk-duplicate`,
    // Admin - Import/Export
    ADMIN_AMENITIES_IMPORT_TEMPLATE: `${API_BASE_URL}/admin/amenities/import/template`,
    ADMIN_AMENITIES_IMPORT_VALIDATE: `${API_BASE_URL}/admin/amenities/import/validate`,
    ADMIN_AMENITIES_IMPORT: `${API_BASE_URL}/admin/amenities/import`,
    ADMIN_AMENITIES_EXPORT: `${API_BASE_URL}/admin/amenities/export`,
    // Admin - Stickers (via sticker-engine)
    ADMIN_STICKER_TEMPLATES: `${API_BASE_URL}/admin/stickers/templates`,
    ADMIN_STICKER_TEMPLATE: `${API_BASE_URL}/admin/stickers/template`,
    ADMIN_STICKERS_RENDER: `${API_BASE_URL}/admin/stickers/render`,
    ADMIN_STICKERS_DOWNLOAD: `${API_BASE_URL}/admin/stickers/download`,
    ADMIN_STICKERS_DOWNLOAD_STATUS: (jobId) => `${API_BASE_URL}/admin/stickers/download/${jobId}`,
    // Admin - Deployment
    ADMIN_DEPLOYMENT_STATUS: `${API_BASE_URL}/admin/deployment/status`,
    ADMIN_DEPLOYMENT_AMENITIES: `${API_BASE_URL}/admin/deployment/amenities`,
    ADMIN_DEPLOYMENT_RESET_DOWNLOADS: `${API_BASE_URL}/admin/deployment/reset-downloads`,
    ADMIN_DEPLOYMENT_MATERIALS: `${API_BASE_URL}/admin/deployment/materials`,
    ADMIN_DEPLOYMENT_ORDERS: `${API_BASE_URL}/admin/deployment/orders`,
    ADMIN_DEPLOYMENT_ORDER: (id) => `${API_BASE_URL}/admin/deployment/orders/${id}`,
    // Admin - Teams
    ADMIN_TEAMS: `${API_BASE_URL}/admin/teams`,
    ADMIN_TEAM: (id) => `${API_BASE_URL}/admin/teams/${id}`,
    ADMIN_TEAM_MEMBERS: (teamId) => `${API_BASE_URL}/admin/teams/${teamId}/members`,
    ADMIN_TEAM_MEMBER: (teamId, userId) => `${API_BASE_URL}/admin/teams/${teamId}/members/${userId}`,
    // Admin - Tenant Logo Library
    ADMIN_LOGOS: `${API_BASE_URL}/admin/logos`,
    ADMIN_LOGO: (id) => `${API_BASE_URL}/admin/logos/${id}`,
    ADMIN_LOGO_DEFAULT: `${API_BASE_URL}/admin/logos/default`,
    ADMIN_LOGO_SET_DEFAULT: (id) => `${API_BASE_URL}/admin/logos/${id}/default`,
    ADMIN_LOGO_UPLOAD_URL: `${API_BASE_URL}/admin/logos/upload-url`,
    // Settings
    ADMIN_SETTINGS: `${API_BASE_URL}/admin/settings`,
    // Admin - Brand kit
    ADMIN_BRAND: `${API_BASE_URL}/admin/brand`,
    ADMIN_BRAND_UPLOAD_URL: `${API_BASE_URL}/admin/brand/upload-url`,
    ADMIN_BRAND_EXTRACT: `${API_BASE_URL}/admin/brand/extract`,
    ADMIN_BRAND_IMPORT: `${API_BASE_URL}/admin/brand/import-asset`,
    ADMIN_BRAND_IMAGE: `${API_BASE_URL}/admin/brand/image.png`,
    // Subscription
    ADMIN_SUBSCRIPTION: `${API_BASE_URL}/admin/subscription`,
    // Wizard
    WIZARD_STATUS: `${API_BASE_URL}/wizard/status`,
    WIZARD_SETUP: `${API_BASE_URL}/wizard/setup`,
    WIZARD_QR_CODES: `${API_BASE_URL}/wizard/qr-codes`,
    WIZARD_QR_CODES_PDF: `${API_BASE_URL}/wizard/qr-codes/pdf`,
    // Billing
    BILLING_PLAN_INFO: `${API_BASE_URL}/billing/plan-info`,
    BILLING_CHECKOUT: `${API_BASE_URL}/billing/checkout`,
    BILLING_PORTAL: `${API_BASE_URL}/billing/portal`,
    BILLING_TRIAL_EXTENSION: `${API_BASE_URL}/billing/trial-extension`,
    // Sharing - Owner endpoints
    SHARING_BASE: `${API_BASE_URL}/sharing`,
    SHARING_INVITE: `${API_BASE_URL}/sharing/invite`,
    SHARING_INVITE_BULK: `${API_BASE_URL}/sharing/invite/bulk`,
    SHARING_SENT: `${API_BASE_URL}/sharing/sent`,
    SHARING_RESEND: (shareId) => `${API_BASE_URL}/sharing/${shareId}/resend`,
    SHARING_UPDATE: (shareId) => `${API_BASE_URL}/sharing/${shareId}`,
    SHARING_REVOKE: (shareId) => `${API_BASE_URL}/sharing/${shareId}`,
    // Sharing - Client endpoints
    SHARING_RECEIVED: `${API_BASE_URL}/sharing/received`,
    SHARING_INVITATIONS: `${API_BASE_URL}/sharing/invitations`,
    SHARING_ACCEPT: (shareId) => `${API_BASE_URL}/sharing/${shareId}/accept`,
    SHARING_DECLINE: (shareId) => `${API_BASE_URL}/sharing/${shareId}/decline`,
    // Sharing - Public endpoints
    SHARING_VERIFY: (token) => `${API_BASE_URL}/sharing/verify/${token}`,
    // Shared Data - Read-only endpoints for clients
    SHARED_BUILDING: (shareId) => `${API_BASE_URL}/shared/buildings/${shareId}`,
    SHARED_AMENITIES: (shareId) => `${API_BASE_URL}/shared/buildings/${shareId}/amenities`,
    SHARED_FEEDBACK: (shareId) => `${API_BASE_URL}/shared/buildings/${shareId}/feedback`,
    SHARED_TASKS: (shareId) => `${API_BASE_URL}/shared/buildings/${shareId}/tasks`,
    SHARED_ANALYTICS: (shareId) => `${API_BASE_URL}/shared/buildings/${shareId}/analytics`,
    // Operator Registry - Tenant relationship management
    OPERATOR_TENANTS: `${API_BASE_URL}/operator/tenants`,
    OPERATOR_TENANT: (identifier) => `${API_BASE_URL}/operator/tenants/${encodeURIComponent(identifier)}`,
    OPERATOR_TENANT_SHARES: (identifier) => `${API_BASE_URL}/operator/tenants/${encodeURIComponent(identifier)}/shares`,
    OPERATOR_TENANT_OFFBOARD: (identifier) => `${API_BASE_URL}/operator/tenants/${encodeURIComponent(identifier)}/offboard`,
    // Super Admin endpoints
    SUPER_ADMIN_TENANTS: `${API_BASE_URL}/super-admin/tenants`,
    SUPER_ADMIN_TENANT: (id) => `${API_BASE_URL}/super-admin/tenants/${id}`,
    SUPER_ADMIN_TENANT_SUSPEND: (id) => `${API_BASE_URL}/super-admin/tenants/${id}/suspend`,
    SUPER_ADMIN_TENANT_ACTIVATE: (id) => `${API_BASE_URL}/super-admin/tenants/${id}/activate`,
    SUPER_ADMIN_SUBSCRIPTIONS: `${API_BASE_URL}/super-admin/subscriptions`,
    SUPER_ADMIN_SUBSCRIPTION_PLAN: (tenantId) => `${API_BASE_URL}/super-admin/subscriptions/${tenantId}/plan`,
    SUPER_ADMIN_SUBSCRIPTION_LIMITS: (tenantId) => `${API_BASE_URL}/super-admin/subscriptions/${tenantId}/limits`,
    SUPER_ADMIN_REVENUE_MRR: `${API_BASE_URL}/super-admin/revenue/mrr`,
    SUPER_ADMIN_ADMINS: `${API_BASE_URL}/super-admin/admins`,
    SUPER_ADMIN_ADMIN: (id) => `${API_BASE_URL}/super-admin/admins/${id}`,
    SUPER_ADMIN_CONFIGS: `${API_BASE_URL}/super-admin/config`,
    SUPER_ADMIN_CONFIG: (key) => `${API_BASE_URL}/super-admin/config/${key}`,
    SUPER_ADMIN_FEATURE_FLAGS: (tenantId) => `${API_BASE_URL}/super-admin/feature-flags/${tenantId}`,
    SUPER_ADMIN_QR_STATS: `${API_BASE_URL}/super-admin/qr-codes/stats`,
    SUPER_ADMIN_QR_BATCHES: `${API_BASE_URL}/super-admin/qr-codes/batches`,
    SUPER_ADMIN_QR_AVAILABLE: `${API_BASE_URL}/super-admin/qr-codes/available`,
    SUPER_ADMIN_ANALYTICS_OVERVIEW: `${API_BASE_URL}/super-admin/analytics/overview`,
    SUPER_ADMIN_ANALYTICS_TENANTS: `${API_BASE_URL}/super-admin/analytics/tenants`,
    SUPER_ADMIN_ANALYTICS_GROWTH: `${API_BASE_URL}/super-admin/analytics/growth`,
    SUPER_ADMIN_AUDIT_LOGS: `${API_BASE_URL}/super-admin/audit-logs`,
    SUPER_ADMIN_AUDIT_LOGS_TENANT: (tenantId) => `${API_BASE_URL}/super-admin/audit-logs/tenant/${tenantId}`,
    SUPER_ADMIN_SECURITY_EVENTS: `${API_BASE_URL}/super-admin/security/events`,
    SUPER_ADMIN_IMPERSONATE: (userId) => `${API_BASE_URL}/super-admin/impersonate/${userId}`,
    SUPER_ADMIN_EXPORT_TENANT: (tenantId) => `${API_BASE_URL}/super-admin/export/tenant/${tenantId}`,
    SUPER_ADMIN_STATUS_TYPES: `${API_BASE_URL}/super-admin/status-types`,
    SUPER_ADMIN_STATUS_TYPE: (id) => `${API_BASE_URL}/super-admin/status-types/${id}`,
    SUPER_ADMIN_RATE_LIMITS: `${API_BASE_URL}/super-admin/rate-limits`,
    SUPER_ADMIN_RATE_LIMIT: (key) => `${API_BASE_URL}/super-admin/rate-limits/${encodeURIComponent(key)}`,
    SUPER_ADMIN_SYSTEM_RESET: `${API_BASE_URL}/super-admin/system/reset`,
    // Super Admin - Seed Data
    SUPER_ADMIN_SEED_INFO: (tenantId) => `${API_BASE_URL}/super-admin/seed-info/${tenantId}`,
    SUPER_ADMIN_SEED_OPERATIONAL_DATA: `${API_BASE_URL}/super-admin/seed-operational-data`,
    SUPER_ADMIN_SEED_SCOUT_DATA: `${API_BASE_URL}/super-admin/seed-scout-data`,
    // Super Admin - Scout Program
    SUPER_ADMIN_SCOUT_OVERVIEW: `${API_BASE_URL}/super-admin/scouts/overview`,
    SUPER_ADMIN_SCOUTS: `${API_BASE_URL}/super-admin/scouts`,
    SUPER_ADMIN_SCOUT: (scoutId) => `${API_BASE_URL}/super-admin/scouts/${scoutId}`,
    SUPER_ADMIN_SCOUT_ACTIVITY: (scoutId) => `${API_BASE_URL}/super-admin/scouts/${scoutId}/activity`,
    SUPER_ADMIN_SCOUT_GROWTH: `${API_BASE_URL}/super-admin/scouts/analytics/growth`,
    SUPER_ADMIN_SCOUT_LEVELS: `${API_BASE_URL}/super-admin/scouts/analytics/levels`,
    // Admin - API Keys
    ADMIN_API_KEYS: `${API_BASE_URL}/admin/api-keys`,
    ADMIN_API_KEY: (id) => `${API_BASE_URL}/admin/api-keys/${id}`,
    // Admin - Webhook Subscribe (Zapier REST Hook)
    ADMIN_WEBHOOKS_SUBSCRIBE: `${API_BASE_URL}/admin/webhooks/subscribe`,
    ADMIN_WEBHOOKS_UNSUBSCRIBE: (id) => `${API_BASE_URL}/admin/webhooks/subscribe/${id}`,
    // Admin - Webhooks
    ADMIN_WEBHOOKS: `${API_BASE_URL}/admin/webhooks`,
    ADMIN_WEBHOOK: (id) => `${API_BASE_URL}/admin/webhooks/${id}`,
    ADMIN_WEBHOOK_DELIVERIES: (id) => `${API_BASE_URL}/admin/webhooks/${id}/deliveries`,
    ADMIN_WEBHOOK_TEST: (id) => `${API_BASE_URL}/admin/webhooks/${id}/test`,
    ADMIN_WEBHOOK_REGENERATE: (id) => `${API_BASE_URL}/admin/webhooks/${id}/regenerate-secret`,
    // Admin - Scout Management
    ADMIN_SCOUTS: `${API_BASE_URL}/admin/scouts`,
    ADMIN_SCOUT: (id) => `${API_BASE_URL}/admin/scouts/${id}`,
    ADMIN_SCOUT_ACTIVITY: (id) => `${API_BASE_URL}/admin/scouts/${id}/activity`,
    ADMIN_SCOUT_INVITE: `${API_BASE_URL}/admin/scouts/invite`,
    ADMIN_SCOUT_INVITE_BULK: `${API_BASE_URL}/admin/scouts/invite/bulk`,
    ADMIN_SCOUT_AWARDS: (id) => `${API_BASE_URL}/admin/scouts/${id}/awards`,
    ADMIN_AWARDS: `${API_BASE_URL}/admin/scouts/awards`,
    ADMIN_AWARD: (id) => `${API_BASE_URL}/admin/scouts/awards/${id}`,
    // Admin - Experiments (Research C2)
    ADMIN_EXPERIMENTS: `${API_BASE_URL}/admin/experiments`,
    ADMIN_EXPERIMENT: (id) => `${API_BASE_URL}/admin/experiments/${id}`,
    ADMIN_EXPERIMENT_LAUNCH: (id) => `${API_BASE_URL}/admin/experiments/${id}/launch`,
    ADMIN_EXPERIMENT_ENROLL: (id) => `${API_BASE_URL}/admin/experiments/${id}/enroll`,
    ADMIN_EXPERIMENT_START: (id) => `${API_BASE_URL}/admin/experiments/${id}/start`,
    ADMIN_EXPERIMENT_PAUSE: (id) => `${API_BASE_URL}/admin/experiments/${id}/pause`,
    ADMIN_EXPERIMENT_RESUME: (id) => `${API_BASE_URL}/admin/experiments/${id}/resume`,
    ADMIN_EXPERIMENT_COMPLETE: (id) => `${API_BASE_URL}/admin/experiments/${id}/complete`,
    ADMIN_EXPERIMENT_ARCHIVE: (id) => `${API_BASE_URL}/admin/experiments/${id}/archive`,
    ADMIN_EXPERIMENT_VARIANTS: (id) => `${API_BASE_URL}/admin/experiments/${id}/variants`,
    ADMIN_EXPERIMENT_EXPORT_SCANS: (id) => `${API_BASE_URL}/admin/experiments/${id}/export/scans`,
    ADMIN_EXPERIMENT_EXPORT_POINTS: (id) => `${API_BASE_URL}/admin/experiments/${id}/export/points`,
    ADMIN_EXPERIMENT_EXPORT_SUMMARY: (id) => `${API_BASE_URL}/admin/experiments/${id}/export/summary`,
    ADMIN_EXPERIMENT_EXPORT_MISSIONS: (id) => `${API_BASE_URL}/admin/experiments/${id}/export/missions`,
    ADMIN_EXPERIMENT_EXPORT_BADGES: (id) => `${API_BASE_URL}/admin/experiments/${id}/export/badges`,
    ADMIN_EXPERIMENT_MANIFEST: (id) => `${API_BASE_URL}/admin/experiments/${id}/manifest`,
    ADMIN_EXPERIMENT_ANALYTICS: (id) => `${API_BASE_URL}/admin/experiments/${id}/analytics`,
    ADMIN_EXPERIMENT_SCOUTS: (id) => `${API_BASE_URL}/admin/experiments/${id}/scouts`,
    ADMIN_SCOUT_ECONOMY: `${API_BASE_URL}/admin/scout-economy`,
    // Admin - Arena Simulation
    ADMIN_EXPERIMENT_SIMULATE: (id) => `${API_BASE_URL}/admin/research/experiments/${id}/simulate`,
    ADMIN_EXPERIMENT_SIMULATIONS: (id) => `${API_BASE_URL}/admin/research/experiments/${id}/simulations`,
    ADMIN_SIMULATION: (simId) => `${API_BASE_URL}/admin/research/simulations/${simId}`,
    ADMIN_SIMULATION_TIMELINE: (simId) => `${API_BASE_URL}/admin/research/simulations/${simId}/timeline`,
    ADMIN_SIMULATION_STEP: (simId) => `${API_BASE_URL}/admin/research/simulations/${simId}/step`,
    ADMIN_SIMULATION_PAUSE: (simId) => `${API_BASE_URL}/admin/research/simulations/${simId}/pause`,
    ADMIN_SIMULATION_RESUME: (simId) => `${API_BASE_URL}/admin/research/simulations/${simId}/resume`,
    ADMIN_SIMULATION_CANCEL: (simId) => `${API_BASE_URL}/admin/research/simulations/${simId}/cancel`,
    // Admin - Cohorts (Research)
    ADMIN_COHORTS: `${API_BASE_URL}/admin/cohorts`,
    ADMIN_COHORT: (id) => `${API_BASE_URL}/admin/cohorts/${id}`,
    ADMIN_COHORT_MEMBERS: (cohortId) => `${API_BASE_URL}/admin/cohorts/${cohortId}/members`,
    ADMIN_COHORT_MEMBER: (cohortId, scoutId) => `${API_BASE_URL}/admin/cohorts/${cohortId}/members/${scoutId}`,
    // Slack Integration
    SLACK_INSTALL: `${API_BASE_URL}/slack/install`,
    SLACK_CALLBACK: `${API_BASE_URL}/slack/callback`,
    SLACK_STATUS: `${API_BASE_URL}/slack/status`,
    SLACK_SETTINGS: `${API_BASE_URL}/slack/settings`,
    SLACK_UNINSTALL: `${API_BASE_URL}/slack/uninstall`,
    // Scout endpoints
    SCOUT_AUTH_REQUEST_LINK: `${API_BASE_URL}/scout/auth/request-link`,
    SCOUT_AUTH_VERIFY: `${API_BASE_URL}/scout/auth/verify`,
    SCOUT_AUTH_REFRESH: `${API_BASE_URL}/scout/auth/refresh`,
    SCOUT_AUTH_ME: `${API_BASE_URL}/scout/auth/me`,
    SCOUT_AUTO_PROVISION: `${API_BASE_URL}/scout/auto-provision`,
    SCOUT_SCAN: `${API_BASE_URL}/scout/scan`,
    SCOUT_PROFILE: `${API_BASE_URL}/scout/profile`,
    SCOUT_POINTS_HISTORY: `${API_BASE_URL}/scout/points/history`,
    SCOUT_POINTS_SUMMARY: `${API_BASE_URL}/scout/points/summary`,
    SCOUT_MEMBERSHIPS: `${API_BASE_URL}/scout/memberships`,
    SCOUT_AWARDS: `${API_BASE_URL}/scout/awards`,
};
// ============================================
// PAGINATION
// ============================================
export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;
// ============================================
// RATING CONFIGURATION
// ============================================
export const RATING_MIN = 1;
export const RATING_MAX = 5;
export const RATING_LABELS = {
    1: 'Very Bad',
    2: 'Bad',
    3: 'Okay',
    4: 'Good',
    5: 'Great',
};
export const RATING_EMOJIS = {
    1: '😞',
    2: '😕',
    3: '😐',
    4: '🙂',
    5: '😊',
};
export const RATING_COLORS = {
    1: '#ef4444', // red-500
    2: '#f97316', // orange-500
    3: '#eab308', // yellow-500
    4: '#84cc16', // lime-500
    5: '#22c55e', // green-500
};
// ============================================
// TASK STATUS CONFIGURATION
// ============================================
export const TASK_STATUS_LABELS = {
    NEW: 'New',
    IN_PROGRESS: 'In Progress',
    COMPLETED: 'Completed',
};
export const TASK_STATUS_COLORS = {
    NEW: '#3b82f6', // blue-500
    IN_PROGRESS: '#f59e0b', // amber-500
    COMPLETED: '#22c55e', // green-500
};
export const TASK_STATUS_BG_COLORS = {
    NEW: '#dbeafe', // blue-100
    IN_PROGRESS: '#fef3c7', // amber-100
    COMPLETED: '#dcfce7', // green-100
};
export const TASK_STATUS_ORDER = ['NEW', 'IN_PROGRESS', 'COMPLETED'];
export const VALID_STATUS_TRANSITIONS = {
    NEW: ['IN_PROGRESS'],
    IN_PROGRESS: ['COMPLETED'],
    COMPLETED: [], // Terminal state
};
// ============================================
// PRIORITY CONFIGURATION
// ============================================
export const PRIORITY_LABELS = {
    CRITICAL: 'Critical',
    STANDARD: 'Standard',
    IMMEDIATE: 'Immediate',
    URGENT: 'Urgent',
    ROUTINE: 'Routine',
    SCHEDULED: 'Scheduled',
};
export const PRIORITY_COLORS = {
    CRITICAL: '#ef4444', // red-500 (critical / legacy)
    STANDARD: '#6b7280', // gray-500 (standard / legacy)
    IMMEDIATE: '#ef4444', // red-500
    URGENT: '#f97316', // orange-500
    ROUTINE: '#6b7280', // gray-500
    SCHEDULED: '#3b82f6', // blue-500
};
export const PRIORITY_BG_COLORS = {
    CRITICAL: '#fee2e2', // red-100 (legacy)
    STANDARD: '#f3f4f6', // gray-100 (legacy)
    IMMEDIATE: '#fee2e2', // red-100
    URGENT: '#ffedd5', // orange-100
    ROUTINE: '#f3f4f6', // gray-100
    SCHEDULED: '#dbeafe', // blue-100
};
// Priority values (legacy)
export const PRIORITY_CRITICAL = 'CRITICAL';
export const PRIORITY_STANDARD = 'STANDARD';
// Priority numeric values (4-level system)
export const PRIORITY_LEVELS = {
    IMMEDIATE: { value: 0, label: 'Immediate', legacyName: 'CRITICAL' },
    URGENT: { value: 1, label: 'Urgent', legacyName: null },
    ROUTINE: { value: 2, label: 'Routine', legacyName: 'STANDARD' },
    SCHEDULED: { value: 3, label: 'Scheduled', legacyName: null },
};
// Default SLA thresholds (minutes) — used before tenant configures custom targets
export const DEFAULT_SLA_THRESHOLDS = {
    IMMEDIATE: { acknowledgeMin: 5, resolveMin: 30 },
    URGENT: { acknowledgeMin: 15, resolveMin: 120 },
    ROUTINE: { acknowledgeMin: 60, resolveMin: 480 },
    SCHEDULED: { acknowledgeMin: 240, resolveMin: 1440 },
    // Legacy mappings
    CRITICAL: { acknowledgeMin: 15, resolveMin: 60 },
    STANDARD: { acknowledgeMin: 60, resolveMin: 480 },
};
// ============================================
// USER ROLE CONFIGURATION
// ============================================
export const USER_ROLE_LABELS = {
    SUPER_ADMIN: 'Super Administrator',
    ADMIN: 'Administrator',
    MANAGER: 'Facility Manager',
    TECHNICIAN: 'Technician',
    CONSUMER_OWNER: 'Household Owner',
    CONSUMER_GRANTEE: 'Household Grantee',
};
export const USER_ROLE_COLORS = {
    SUPER_ADMIN: '#dc2626', // red-600
    ADMIN: '#8b5cf6', // violet-500
    MANAGER: '#3b82f6', // blue-500
    TECHNICIAN: '#10b981', // emerald-500
    CONSUMER_OWNER: '#f59e0b', // amber-500
    CONSUMER_GRANTEE: '#06b6d4', // cyan-500
};
export const USER_ROLE_ORDER = ['SUPER_ADMIN', 'ADMIN', 'MANAGER', 'TECHNICIAN'];
// Tenant-scoped roles for TL building tenants (excludes SUPER_ADMIN and Carnaf roles)
export const TENANT_ROLE_ORDER = ['ADMIN', 'MANAGER', 'TECHNICIAN'];
// Carnaf household-tenant roles. CONSUMER_OWNER is the household admin;
// CONSUMER_GRANTEE represents a permission-grant relationship inside someone
// else's household tenant.
export const CARNAF_ROLE_ORDER = ['CONSUMER_OWNER', 'CONSUMER_GRANTEE'];
// ============================================
// COMMON AMENITY TYPE ICONS
// ============================================
export const AMENITY_TYPE_ICONS = {
    washroom: '🚻',
    restroom: '🚻',
    bathroom: '🚻',
    kitchen: '🍳',
    pantry: '🍳',
    break_room: '☕',
    meeting_room: '🏢',
    conference_room: '🏢',
    lounge: '🛋️',
    lobby: '🏛️',
    parking: '🅿️',
    elevator: '🛗',
    stairwell: '🪜',
    gym: '💪',
    fitness: '💪',
    cafeteria: '🍽️',
    outdoor: '🌳',
    reception: '🛎️',
    default: '📍',
};
// ============================================
// DATE/TIME FORMATS
// ============================================
export const DATE_FORMAT = 'MMM d, yyyy';
export const TIME_FORMAT = 'h:mm a';
export const DATETIME_FORMAT = 'MMM d, yyyy h:mm a';
export const ISO_DATE_FORMAT = 'yyyy-MM-dd';
// ============================================
// VALIDATION LIMITS
// ============================================
export const MAX_COMMENT_LENGTH = 500;
export const MAX_NOTE_LENGTH = 500;
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 100;
export const MAX_NAME_LENGTH = 255;
export const MAX_DESCRIPTION_LENGTH = 1000;
export const MAX_BULK_QR_CODES = 100;
// ============================================
// QR CODE CONFIGURATION
// ============================================
/**
 * Number of digits for sequential QR code generation (legacy).
 * Format: TL-00000001 to TL-99999999
 * 8 digits provides ~100M codes for better enumeration resistance.
 * @deprecated Use QR_CODE_RANDOM_LENGTH + QR_CODE_RANDOM_ALPHABET for new stock codes.
 */
export const QR_CODE_SEQUENTIAL_DIGITS = 8;
/**
 * Unambiguous alphabet for random QR code generation.
 * 32 characters: excludes 0/O and 1/I to prevent misreading from physical stickers.
 * L is kept since 1 and I are already excluded, making L unambiguous in uppercase context.
 */
export const QR_CODE_RANDOM_ALPHABET = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';
/**
 * Number of random characters in stock QR codes.
 * 6 chars from 32-char alphabet = 32^6 = ~1 billion combinations.
 */
export const QR_CODE_RANDOM_LENGTH = 6;
/**
 * Default prefix for TendedLoop QR codes.
 */
export const QR_CODE_DEFAULT_PREFIX = 'TL';
/**
 * Regex pattern for validating QR code format.
 * Matches: XX-XXXXXXXX (2-4 letter prefix, dash, alphanumeric code)
 *
 * Currently only "TL" prefix is used, but regex allows 2-4 letters for:
 * - Future multi-tenant white-labeling (custom prefixes)
 * - Demo/test prefixes (e.g., "DEMO-xxx")
 * - Regional prefixes if needed (e.g., "TLEU-xxx")
 *
 * Note: feedback.schemas.ts and status.schemas.ts have inline copies of this regex.
 * Keep them in sync if modified.
 */
export const QR_CODE_FORMAT_REGEX = /^[A-Z]{2,4}-[A-Z0-9]([A-Z0-9-]{0,28}[A-Z0-9])?$/i;
/**
 * Soft delete retention period in days.
 * Soft-deleted QR codes are permanently removed after this period.
 */
export const QR_CODE_SOFT_DELETE_RETENTION_DAYS = 90;
// ============================================
// SECURITY CONSTANTS
// ============================================
/**
 * BCrypt salt rounds for password hashing.
 * 12 rounds is the industry standard for 2024+, providing good security
 * while keeping hash time reasonable (~250ms).
 */
export const BCRYPT_SALT_ROUNDS = 12;
/**
 * JWT token expiry times.
 */
export const JWT_EXPIRY = '15m';
export const REFRESH_TOKEN_EXPIRY = '30d';
/**
 * Magic link expiry in minutes.
 */
export const MAGIC_LINK_EXPIRY_MINUTES = 15;
/**
 * Password reset token expiry in hours.
 */
export const PASSWORD_RESET_EXPIRY_HOURS = 1;
/**
 * Email verification token expiry in hours.
 */
export const EMAIL_VERIFICATION_EXPIRY_HOURS = 24;
// ============================================
// STATUS CONSTANTS
// ============================================
/**
 * Status values that indicate an issue needing attention.
 * Used for calculating "active issues" in dashboards.
 */
export const BAD_STATUSES = new Set([
    'LOW',
    'EMPTY',
    'ISSUE',
    'NOT_WORKING',
    'NEEDS_ATTENTION',
    'DIRTY',
    'UNCOMFORTABLE',
]);
/**
 * Status values that indicate normal/good condition.
 */
export const GOOD_STATUSES = new Set(['FULL', 'OK', 'HIGH', 'WORKING', 'CLEAN', 'COMFORTABLE']);
/**
 * Get the default status value for a status category.
 * IMPORTANT: This is the single source of truth. All modules should import this.
 *
 * @param category - The status category (CONSUMABLE, EQUIPMENT, CLEANLINESS, COMFORT)
 * @returns The default status string for that category
 */
// ============================================
// API KEY CONFIGURATION
// ============================================
export const API_KEY_PREFIX = 'tl_k_';
export const API_KEY_SCOPES = ['read', 'write', 'webhooks:manage'];
// ============================================
// WEBHOOK CONFIGURATION
// ============================================
export const WEBHOOK_EVENTS = [
    'task.created',
    'task.acknowledged',
    'task.completed',
    'task.reassigned',
    'task.escalated',
    'feedback.received',
    'status.reported',
    'scout.scan',
    'scout.xp_awarded',
    'scout.level_up',
    'scout.mission_completed',
    'scout.badge_earned',
    'scout.streak_milestone',
];
export const WEBHOOK_MAX_RETRIES = 5;
export const WEBHOOK_RETRY_DELAYS_MS = [30_000, 120_000, 900_000, 3_600_000, 14_400_000]; // 30s, 2m, 15m, 1h, 4h
export function getDefaultStatus(category) {
    switch (category) {
        case 'CONSUMABLE':
            return 'FULL';
        case 'EQUIPMENT':
            return 'WORKING';
        case 'CLEANLINESS':
            return 'CLEAN';
        case 'COMFORT':
            return 'COMFORTABLE';
        default:
            return 'OK';
    }
}
// ---------------------------------------------------------------------------
// Housing (student accommodation) domain rules
// ---------------------------------------------------------------------------
/**
 * Business rule: an apartment can be occupied by at most this many people.
 * Enforced as a hard invariant at bed structure (no apartment gets more beds)
 * and at assignment (no third active occupant). Studios stay single-occupancy;
 * two-room units hold two. This is a ceiling, not a target.
 */
export const HOUSING_MAX_OCCUPANTS_PER_APARTMENT = 2;
/**
 * Pipeline stages that come before a signed contract. A lead in one of these
 * stages advances to CONTRACT_SIGNED the moment a contract is actually signed
 * (resident e-signature, or an operator recording a paper signature).
 */
export const HOUSING_PRE_CONTRACT_STAGES = ['LEAD_NEW', 'TOUR_SCHEDULED', 'TOUR_COMPLETED'];
/**
 * What a blank in an operator's contract template can be filled with. Only data
 * the system actually holds is offered; anything else (e.g. a municipal account
 * number, a management fee) is mapped to `blank` and left for hand-filling.
 * `sign*` slots are filled at the moment the resident signs, not when the
 * document is prepared.
 */
export const HOUSING_LEASE_TEMPLATE_FIELDS = [
    { key: 'lastName', label: 'שם משפחה' },
    { key: 'firstName', label: 'שם פרטי' },
    { key: 'idNumber', label: 'ת.ז / דרכון' },
    { key: 'homeAddress', label: 'כתובת קבועה' },
    { key: 'phone', label: 'טלפון נייד' },
    { key: 'email', label: 'דוא"ל' },
    { key: 'building', label: 'מבנה' },
    { key: 'floor', label: 'קומה' },
    { key: 'unit', label: 'יחידה' },
    { key: 'startDate', label: 'תחילת התקופה' },
    { key: 'endDate', label: 'סוף התקופה' },
    { key: 'monthlyRent', label: 'דמי הרשאה חודשיים' },
    { key: 'managementFee', label: 'דמי ניהול ואחזקה' },
    { key: 'parkingFee', label: 'חניה' },
    { key: 'internetFee', label: 'אינטרנט' },
    { key: 'partnerFee', label: 'תוספת בן/בת זוג' },
    { key: 'electricityFee', label: 'חשמל' },
    { key: 'monthlyTotal', label: 'סה"כ לחודש' },
    { key: 'arnonaNumber', label: 'מספר נכס בארנונה' },
    { key: 'waterNumber', label: 'מספר נכס במי אביבים' },
    { key: 'signDay', label: 'יום החתימה' },
    { key: 'signMonth', label: 'חודש החתימה' },
    { key: 'signYear', label: 'שנת החתימה' },
    { key: 'blank', label: 'להשאיר ריק' },
];
export const HOUSING_LEASE_SIGN_FIELD_KEYS = ['signDay', 'signMonth', 'signYear'];
/** Template fields whose value is set once on the template (same in every contract). */
export const HOUSING_LEASE_FIXED_FIELD_KEYS = ['managementFee'];
/**
 * Housing apartment status, the one definition the API, the map and every count share.
 * An apartment is the unit of occupancy: the office counts apartments, never people or
 * bed rows (each apartment holds two internal bed rows, for one person or a couple).
 * "Occupied" includes an assigned person whose key is still pending, matching the
 * office's status report. A reservation is held apart from it and is not for marketing.
 */
export const HOUSING_APARTMENT_STATES = [
    'occupied',
    'assigned',
    'reserved_occupied',
    'reserved_vacant',
    'vacant',
    'blocked',
];
/**
 * A couple lives here: two people on file, or one marked as living with a partner. (One
 * person on both internal rows is not a couple; the office's import looks like that.)
 */
export function housingApartmentIsCouple(beds) {
    const stays = beds.flatMap((b) => b.assignments ?? []).filter((a) => a.status !== 'HELD');
    return stays.some((a) => a.couple) || new Set(stays.map((a) => a.personId)).size > 1;
}
/**
 * This stay is still owed its key. An imported stay with no key date, of someone still at
 * "assigned", counts; a resident with a blank key date has simply moved in.
 */
export function housingStayAwaitsKey(a) {
    if (a.status === 'ASSIGNED' || a.status === 'RESERVED')
        return true;
    return a.status === 'ACTIVE' && a.keyStatus === 'NONE' && a.person?.stage === 'ASSIGNED';
}
/**
 * Someone here awaits a key. Kept apart from the apartment state on purpose: a partner
 * waiting beside a moved-in resident leaves the apartment "occupied" in every figure.
 */
export function housingApartmentAwaitsKey(beds) {
    return beds.some((b) => (b.assignments ?? []).some(housingStayAwaitsKey));
}
export function housingApartmentState(beds) {
    const stays = beds.flatMap((b) => b.assignments ?? []);
    const movedIn = stays.some((a) => a.status === 'ACTIVE' && !housingStayAwaitsKey(a));
    const assigned = stays.some(housingStayAwaitsKey);
    const occupied = movedIn || assigned || beds.some((b) => b.currentStatus === 'OCCUPIED');
    const reserved = stays.some((a) => a.status === 'HELD') ||
        beds.some((b) => b.currentStatus === 'RESERVED' && !(b.assignments ?? []).length);
    if (occupied && reserved)
        return 'reserved_occupied';
    if (movedIn)
        return 'occupied';
    if (assigned)
        return 'assigned';
    if (occupied)
        return 'occupied';
    if (reserved)
        return 'reserved_vacant';
    if (beds.some((b) => b.currentStatus === 'BLOCKED'))
        return 'blocked';
    return 'vacant';
}
/** The Apartments page's `show` chips, so the map and its export can never disagree. */
export function housingApartmentMatchesShow(show, beds) {
    const state = housingApartmentState(beds);
    if (show === 'free')
        return state === 'vacant';
    if (show === 'key')
        return housingApartmentAwaitsKey(beds);
    if (show === 'reserved')
        return state === 'reserved_vacant' || state === 'reserved_occupied';
    if (show === 'couples')
        return housingApartmentIsCouple(beds);
    return true;
}
/** `unit` filter value for the apartments of a walled type that have no W or G on record. */
export const HOUSING_UNIT_NO_WALL = 'none';
/** `unit` filter: "SA" is the whole type, "SA W" one wall, "SA none" only those with no wall. */
export function housingUnitMatches(filter, unitCode, wall) {
    return !filter || filter === unitCode || filter === `${unitCode} ${wall || HOUSING_UNIT_NO_WALL}`;
}
/** Counts apartment states into the figures every housing surface shows. */
export function housingOccupancyCounts(states) {
    const n = (...of) => states.filter((s) => of.includes(s)).length;
    const total = states.length;
    const occupied = n('occupied', 'assigned', 'reserved_occupied');
    return {
        apartments_total: total,
        apartments_occupied: occupied,
        apartments_assigned: n('assigned'),
        apartments_reserved: n('reserved_vacant', 'reserved_occupied'),
        apartments_to_market: n('vacant'),
        apartments_blocked: n('blocked'),
        occupancy_pct: total ? Math.round((occupied * 1000) / total) / 10 : 0,
    };
}
//# sourceMappingURL=constants.js.map